import React from 'react'
import Carousal from './carousal'
import Services from './services'
import Achievements from './achievments'
import Projects from './projects'
import Getquote from './getquote'
import Footer from './footer'
import BrandDevelopment from './brandevelopment'
import MetaDecorator from './metadecorator'
import ReviewedPlatforms from './ReviewedPlatforms'
import ReviewedPlatformsHome from './ReviewedPlatformsHome'
import GoogleReviewsSection from './GoogleReviewsSection'
import AppDevelopmentBlogs from './AppDevelopmentBlogs'
import GoogleReviewsSectionHome from './GoogleReviewsSectionHome'
import {
  createBreadcrumbList,
  createSchemaGraph,
  createServiceItemList,
  createWebPageSchema,
  organizationSchema,
  websiteSchema
} from '../utils/schemaMarkup'

const Home = ({title,description,showBrand}) => {
  const imageUrl = "https://res.cloudinary.com/l7pafu4a/image/upload/v1720099375/silhlgsrj9ehcuq3gm4h.png"
  const homeBreadcrumb = createBreadcrumbList([
    { name: 'Home', url: '/' }
  ])
  const homeMainEntity = createServiceItemList({
    id: 'https://metatech-official.com/#home-services',
    name: 'Metatech Official Core Services',
    description: 'Primary software development and digital marketing services offered by Metatech Official.',
    items: [
      { title: 'Website Development', slug: '/website-development', summary: 'Custom website development services for business websites, ecommerce websites, and high-performance web experiences.' },
      { title: 'Mobile App Development', slug: '/app-development', summary: 'Mobile app development services for iOS, Android, cross-platform, and custom app products.' },
      { title: 'Search Engine Optimization', slug: '/seo', summary: 'SEO services for organic visibility, technical SEO, content growth, and search performance.' },
      { title: 'Google Ads PPC', slug: '/ppc-management-packages', summary: 'Google Ads PPC management services for paid search campaigns, conversion tracking, and lead generation.' }
    ]
  })
  const schemaMarkup = createSchemaGraph([
    organizationSchema,
    websiteSchema,
    createWebPageSchema({
      path: '/',
      title,
      description,
      imageUrl,
      breadcrumb: homeBreadcrumb,
      mainEntity: homeMainEntity
    }),
    homeBreadcrumb,
    homeMainEntity
  ])

  return (
    <>
    <MetaDecorator showBrand={showBrand} title={title} imageUrl={imageUrl} description={description} schemaMarkup={schemaMarkup} />
      <Carousal />
                        <ReviewedPlatformsHome />

      <Services />
      <div style={{ backgroundImage: `url(https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60,w_${window.innerWidth},h_${window.innerHeight}/https://img.freepik.com/free-vector/dark-gradient-background-with-copy-space_53876-99548.jpg)`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
        <Achievements />
        <Projects />
<BrandDevelopment/>
<div style={{ background: "linear-gradient(rgba(0,0,0,0), rgba(0,0,0,1))" }}>
        {/* <GoogleReviewsSectionHome /> */}
        <AppDevelopmentBlogs
          eyebrow="LATEST NEWS"
          heading="Latest News & Insights"
          filterByApp={false}
          latestFirst
        />
        <Getquote />
        </div>
      </div>
    </>
  )
}
export default Home
